import { defineComponent as _defineComponent } from 'vue'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
  import { Bar } from 'vue-chartjs/legacy'
  import type { PropType } from 'vue'
  import type { BarChartData } from '@/services/interfaces/Common'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BarChart',
  props: {
    chartId: {
      type: String,
      default: 'bar-chart',
    },
    datasetIdKey: {
      type: String,
      default: 'label',
    },
    chartData: {
      type: Object as PropType<BarChartData>,
      required: true,
    },
    showLegendLabel: {
      type: Boolean,
      default: true,
    },
    maxYAxes: Number,
    height: {
      type: Number,
      default: 275,
    },
  },
  setup(__props) {

const props = __props;

  ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

  
  const chartOptions = {
    responsive: true,
    scales: {
      yAxes: {
        max: props.maxYAxes,
      },
    },
    plugins: {
      legend: {
        display: props.showLegendLabel,
      },
    },
  }

return { __sfc: true,props, chartOptions, ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, Bar }
}

})